<template>
  <div>
    <h3><el-page-header @back="$router.push('../.')" :content="title" /></h3>

    <el-row :gutter="20">
      <el-col :span="18">
        <div
          id="mapDiv"
          style="min-height: 680px; border: solid 1px #ccc"
        ></div>
      </el-col>
      <el-col :span="6">
        <el-button
          type="primary"
          size="small"
          :disabled="btnStatus"
          @click="save"
          >保存地块地理数据</el-button
        >
        <h4>操作说明</h4>
        <p style="line-height: 180%; color: #666">
          用鼠标拖动边界上的点到正确位置，编辑完成后点击上方“保存”按钮即可完成。
        </p>
        <p style="line-height: 180%; color: #666">
          如果该地块此前从未绘制地理边界，那么请先拖动和缩放地图，找到地块所在大致位置之后，点击
          <el-link :disabled="radio2" type="danger" @click="showMap"
            >这里</el-link
          >
          初始化一个边界，然后即可编辑。
        </p>
        <p style="line-height: 180%; color: #666">
          小贴士：用鼠标按住地图拖动，可移动地图；用鼠标滚轮上下滚动，可改变地图比例尺。
        </p>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import LocateMap from './locate-map.js'
import { updateAreaData } from '@/api/land.js'
import { getLandInPark, getLandDetail } from '@/api/land2.js'
import { getPark } from '@/api/park2.js'

export default {
  name: 'LandLocate',
  data() {
    return {
      local: null,
      park: undefined,
      map: undefined,
      /**
       * 地图是否已加载
       */
      mapLoaded: false,
      /**
       * 地图是否已加载
       */
      radio2: true,
      btnStatus: false,
      landLine: undefined,
    }
  },
  computed: {
    /**
     * 当前地块的id
     */
    id() {
      return this.$route.params.id
    },
    title() {
      return `在园区中定位和绘制地块 `
    },
  },
  created() {},
  mounted() {
    //获取地块数据
    getLandDetail(this.id).then((data) => {
      getPark(data.data.parkId).then((resp) => {
        this.park = resp.data[0]
        if (this.park) {
          // 然后初始化地图，初始化完成以后，map对象内部会设置mapLoaded为true
          LocateMap.init2('mapDiv', this)
        } else {
          // TODO 没有地块的处理，界面要有相应显示
        }
      })
      getLandInPark(data.data.parkId).then((r) => {
       r.data.splice(
          r.data.findIndex((e) => e.id === data.data.id),
          1
        )
        this.landLine=r.data
      })
    })

    // 当前地块的轮廓地理数据。应该先调用相关api提取当前地块的信息，其中包含了轮廓字段。
    const outline = undefined
    // 初始化地图
  },
  watch: {
    // /**
    //  * 监听地图加载。根据当前地块绘制地图内容
    //  */
    mapLoaded: function () {
      this.draw()
    },
  },
  methods: {
    // 关闭编辑
    closeEdit() {},
    // 保存
    save() {
      var array = LocateMap.getPath()
      let option = {}
      option.name = ''
      option.acreage = ''
      option.parkId = ''
      option.id = this.$route.params.id
      option.position = array[0]
      option.lng = array[1]
      option.lat = array[2]
      updateAreaData(option).then((data) => {
        // this.areaId = undefined
        // // this.landSearch()
        // this.dialogFormVisible = false
        // this.$refs['form'].resetFields()
        this.$message.success('提交成功')
      })
    },

    draw() {
      // 地图加载了并且当前park可用，则绘制园区和地块
      const mapLoaded = this
      if (mapLoaded) {
        if (this.park.position) {
          let arr = [this.park]
          arr.push(...this.landLine)
          LocateMap.drawPark2(arr)
        } else {
          this.btnStatus = true
          alert('请先绘制园区')
          return
        }
        getLandDetail(this.id).then((resp) => {
          if (resp.data.position) {
            LocateMap.drawLands(resp.data)
          } else {
            this.radio2 = false
          }
        })
        // LocateMap.drawing()
      }
    },
    showMap() {
      LocateMap.drawOutLine()
      this.radio2 = true
    },
  },
  beforeDestroy() {
    LocateMap.destroy()
  },
}
</script>


// WEBPACK FOOTER //
// src/components/meta/land/Locate.vue